module.exports = __webpack_public_path__ + "static/media/flipkart.23f6357b.png";